import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getArticleBySlug } from '@/mocks/articles';

const pillarSlugs = [
  'usfans-spreadsheet-what-is',
  'usfans-spreadsheet-find',
  'usfans-spreadsheet-use',
  'usfans-spreadsheet-search',
  'usfans-spreadsheet-products',
  'usfans-spreadsheet-sellers',
  'usfans-spreadsheet-categories',
  'usfans-spreadsheet-directory',
  'usfans-spreadsheet-comparison',
  'usfans-spreadsheet-beginner',
];

export default function PillarArticles() {
  const { t } = useTranslation();

  const articles = pillarSlugs
    .map((slug) => getArticleBySlug(slug))
    .filter((a): a is NonNullable<typeof a> => Boolean(a));

  return (
    <section id="pillars" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
            <i className="ri-stack-line text-sm mr-1" />
            {t('pillars.eyebrow')}
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-heading font-semibold text-foreground-950">{t('pillars.title')}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{t('pillars.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guides/${article.slug}`}
              className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-36 overflow-hidden">
                <img
                  src={article.image}
                  alt={`${article.title} — USFans Spreadsheet`}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute left-3 top-3 w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/95 text-primary-600">
                  <i className={`${article.icon} text-base`} />
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <span className="text-xs font-semibold text-accent-600 uppercase tracking-wide whitespace-nowrap">{article.category}</span>
                <h3 className="mt-2 text-sm font-semibold text-foreground-950 leading-snug line-clamp-2">{article.title}</h3>
                <span className="mt-auto pt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  {t('guides.readMore')}
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}